import styled from "styled-components";

export const CmpTextInput = styled.div`
`;
